import { KeybanBaseError } from "./KeybanBaseError";

/**
 * Error types for iframe API integration.
 */
export enum IFrameApiErrorType {
  InvalidOrigin = "InvalidOrigin",
  InvalidCall = "InvalidCall",
}

/**
 * Error thrown by the iframe API server/client layer.
 * @example
 * throw new IFrameApiError(IFrameApiErrorType.InvalidOrigin, "ApiServer.checkEventOrigin");
 */
export class IFrameApiError extends KeybanBaseError<IFrameApiErrorType> {
  static types = IFrameApiErrorType;

  constructor(type: IFrameApiErrorType, instance: string, rootError?: Error) {
    super({
      type,
      instance,
      rootError,
      title: IFrameApiError.#getTitle(type),
    });
  }

  static #getTitle(errorType: IFrameApiErrorType): string {
    switch (errorType) {
      case IFrameApiErrorType.InvalidOrigin:
        return "The current domain is not allowed for this appId";

      case IFrameApiErrorType.InvalidCall:
        return "Invalid method call, either the method does not exists or is not allowed";

      default:
        return `Unknown error type: ${errorType}`;
    }
  }
}
